import mapFunction from './mapResources';

export default mapFunction('employees_masters_project_managers', {
    isFetching: false,
    items: [] 
});
